import { StatisticColorByStepCalc } from '@app/utils/statistic-color-by-step';
import { ApexOptions } from 'apexcharts';
import ApexChart from 'react-apexcharts';

import React from 'react';
export const MonitoringScoreDiagramHalf = ({
  score,
  height = 250,
  width,
  maxScore,
  fontSize,
  formatting,
}: {
  score: number;
  maxScore: number;
  height?: number;
  width?: number;
  fontSize?: string;
  formatting?: {
    color: string;
    value: number[];
    desc: string;
    count: number;
    pct: number;
  }[];
}) => {
  const fillScore = Number(Math.min((score / maxScore) * 100, 100).toFixed(1)) || 0;
  const standardColor = StatisticColorByStepCalc({ max: maxScore, score: score });

  function colorByFormatting() {
    return (
      formatting?.find(({ value }) => {
        return value[0] <= score && score <= value[1];
      })?.color || '#2987CC'
    );
  }

  const options: ApexOptions = {
    chart: {
      type: 'radialBar',
      offsetY: -20,
      animations: { enabled: false },
      sparkline: {
        enabled: true,
      },
    },
    colors: [formatting ? colorByFormatting() || standardColor : standardColor],
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,

        dataLabels: {
          name: {
            show: false,
          },
          value: {
            color: '#888',
            fontWeight: 900,
            offsetY: -2,
            fontSize: fontSize || '22px',
            formatter: () => String(score),
          },
        },
      },
    },
    // labels: ['Average Results'],
  };

  return (
    <ApexChart
      type="radialBar"
      height={height}
      width={width}
      series={[fillScore]}
      options={options}
    />
  );
};
